import { mintCircuitId } from "../addedCircuits";
import { CATEGORY_SHORT, UNKNOWN_CATEGORY_SHORT } from "../deviceCategories";
import type { NextCircuitKey } from "./types";


export const nextCircuitKey: NextCircuitKey = ({ category, boardName, takenIds }) => {
  const prefix = category ? CATEGORY_SHORT[category] : UNKNOWN_CATEGORY_SHORT;
  for (let n = 1; ; n += 1) {
    const key = `${prefix}${n}`;
    if (!takenIds.has(mintCircuitId({ key, boardName }))) return key;
  }
};
